// // MODIFIED: Cleaned up unused legacy methods
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const changeScheduleService = {
  getByEmployee: async (employeeId) => {
    return await axios.get(`${domain}/api/ChangeScheduleRequest/employee/${employeeId}`, { headers });
  },

  getShiftSchedules: async () => {
    return await axios.get(`${domain}/api/ShiftSchedule`, { headers });
  },

  create: async (payload) => {
    // Backend handles the creation of both the Request and the Approval row in one transaction.
    return await axios.post(`${domain}/api/ChangeScheduleRequest`, payload, { headers });
  },

};

export default changeScheduleService;